function synceOfflineData(offlineData) {
  console.log("syncing...");

  $("#content").append(
    `<div id="sync-offline-data-loader" 
     class="position-fixed w-100 h-100 d-none d-flex flex-column justify-content-center align-items-center" 
     style="top: 0; left: 0; background-color: rgba(0, 0, 0, 0.5); z-index: 1050;">
    
    <!-- Spinner -->
    <div class="spinner-border text-light" 
         style="width: 4rem; height: 4rem;" 
         role="status">
    </div>

    <div class="mt-4 text-light font-weight-bold">
        Synkroniserer frakoblet data...
    </div>
</div>`
  );
  const offlineOrder = offlineData.offlineOrder;
  const offlineOrderProduct = offlineData.offlineOrderProduct;
  const offlineProductTable = offlineData.offlineProductTable;
  $.ajax({
    url: "/api/v1/offline-mode/synce-offline-data",
    method: "POST",
    data: {
      offlineOrder,
      offlineOrderProduct,
      offlineProductTable,
    },
  })
    .done(function (data) {
      console.log("synced");

      if (window.ReactNativeWebView && data.success) {
        const message = {
          action: "offline_mode",
          data: {
            action: "synced_to_online_db",
            data,
          },
        };
        window.ReactNativeWebView.postMessage(JSON.stringify(message));
        setTimeout(() => {
          $("#sync-offline-data-loader").remove();
          popupAlert();
        }, 1000);
      }
    })
    .fail(function (err) {
      console.error("Error fetching data:", err);
    });
}

$(document).ready(function () {
  let p = $("body").attr("p");
  let organizerId = $("body").attr("organizer_id");

  const locationId = $("#classic-location-products").attr("data-location-id");
  const userId = $("#classic-location-products").attr("data-user-id");

  function fetchDataAndSend() {
    $.ajax({
      url: "/api/v1/offline-mode/get-data",
      method: "POST",
      data: {
        organizer_id: organizerId,
      },
    })
      .done(function (data) {
        if (window.ReactNativeWebView) {
          const message = {
            action: "offline_mode",
            data: {
              action: "save_to_db",
              data,
            },
          };
          window.ReactNativeWebView.postMessage(JSON.stringify(message));
        }
      })
      .fail(function (err) {
        console.error("Error fetching data:", err);
      });
  }

  fetchDataAndSend();

  // Then repeat every 10 minutes (600000 ms)
  setInterval(fetchDataAndSend, 1 * 60 * 1000);
});
